import React, { useContext, useEffect, useState } from "react";
import List, { STATE } from "../../List/index";
import SecondaryPagination from "../../SecondaryPagination/SecondaryPagination";

import { ReactComponent as ManagePrioritySvg } from "../../../assets/admin/icons/manage-priority.svg";
import { ReactComponent as PreviewPageSvg } from "../../../assets/admin/icons/preview-page.svg";
import { ReactComponent as AddSvg } from "../../../assets/admin/icons/add-color.svg";
import { ReactComponent as DeleteColorSvg } from "../../../assets/admin/icons/delete-color.svg";
import { ReactComponent as DeleteDisableSvg } from "../../../assets/admin/icons/delete-disable.svg";
import { ReactComponent as EyeSvg } from "../../../assets/admin/icons/eye.svg";

import SearchBox from "../SearchBox";
import useUsers from "../../../hooks/useUsers";
import { format } from "date-fns";
import useLandingPage from "../../../hooks/useLandingPage";
import Customer from "./Customer";
import AppContext from "../../../AppContext";

const columns = [
  {
    display: "#",
    key: "no",
    textAlign: "left",
    maxWidth: 20,
  },
  {
    display: "UID",
    key: "uid",
    textAlign: "left",
    maxWidth: 60,
  },
  {
    display: "Name",
    key: "name",
    textAlign: "left",
  },
  {
    display: "Plan",
    key: "plan",
    textAlign: "left",
  },
  {
    display: "Registered",
    key: "createdOn",
    textAlign: "left",
  },
  {
    display: "Status",
    key: "status",
    textAlign: "left",
  },
  {
    display: "",
    key: "actions",
    textAlign: "left",
    maxWidth: 50,
  },
];

const Customers = () => {
  const [dataState, setDataState] = useState(STATE.LOADING);
  const [users, setUsers] = useState(undefined);
  const [metadata, setMetadata] = useState(undefined);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({});
  const [selectedUser, setSelectedUser] = useState(undefined);
  const { plans } = useContext(AppContext);

  const { queryUsers } = useUsers();

  useEffect(() => {
    fetchData();
    return () => {};
  }, []);

  useEffect(() => {
    fetchData();
  }, [filter, limit, page]);

  // * Fetch data
  const fetchData = async () => {
    const { data, _metadata } = await queryUsers(
      {
        active: true,
        deleted: false,
        plan: {
          $nin: plans
            .filter((p) => ["Guest"].includes(p.name))
            .map((p) => p._id),
        },
        ...filter,
      },
      page,
      limit,
      null,
      {
        createdOn: 1,
      }
    );

    // * Map data to display
    const _users = data.map(
      ({ _id, no, firstname, surname, email, plan, createdOn, status }, i) => ({
        no: (page - 1) * limit + i + 1,
        uid: (no || "").toString().padStart(6, "0"),
        name: `${firstname} ${surname || ""}`,
        email,
        plan: plans.find((p) => p._id === plan)?.name || "-",
        createdOn: format(new Date(createdOn), "dd/MM/yyyy"),
        status: getUserStatus(status),
        actions: (
          <div className="admin-verification-users-lists-actions">
            <div
              className="admin-verification-users-lists-actions-view"
              onClick={() => handleViewUserClick(_id)}
            >
              <EyeSvg />
            </div>
          </div>
        ),
      })
    );

    setUsers(_users);
    setMetadata(_metadata);
    setDataState(STATE.IDLE);
  };

  const getUserStatus = (status) => {
    if (status === 1) {
      return (
        <div className="admin-verification-users-lists-status admin-verification-users-lists-status--pending">
          Pending
        </div>
      );
    }

    if (status === 2) {
      return (
        <div className="admin-verification-users-lists-status admin-verification-users-lists-status--approved">
          Approved
        </div>
      );
    }

    return (
      <div className="admin-verification-users-lists-status admin-verification-users-lists-status--rejected">
        Rejected
      </div>
    );
  };

  const handleOnPageChange = (page) => setPage(page);

  const handleOnLimitChange = (limit) => setLimit(limit);

  const handleSearchChange = (value) => {
    if (!value) {
      setFilter({});
      return;
    }

    setPage(1);
    setFilter({
      $or: [
        {
          no: isNaN(value) ? 0 : +value,
        },
        {
          firstname: { $regex: value },
        },
        {
          surname: { $regex: value },
        },
      ],
    });
  };

  const handleViewUserClick = (id) => {
    setSelectedUser(id);
  };

  const handleCloseViewUser = () => {
    setSelectedUser(undefined);
    fetchData();
  };

  return (
    <>
      <div className="admin-lp-hb">
        <div className="admin-lp-hb-header">
          <SearchBox placeholder="UID or name" onChange={handleSearchChange} />
        </div>
        <List
          contentState={dataState}
          columns={columns}
          dataSource={users}
          viewable={false}
        >
          <SecondaryPagination
            limits={[10, 50]}
            defaultPage={metadata?.currentPage || 1}
            pages={metadata?.totalPages || 1}
            defaultLimit={metadata?.pageSize}
            onPageChange={handleOnPageChange}
            onLimitChange={handleOnLimitChange}
          />
        </List>
      </div>
      {selectedUser && (
        <Customer
          userId={selectedUser}
          onClose={handleCloseViewUser}
          onSuccess={handleCloseViewUser}
        />
      )}
    </>
  );
};

Customers.propTypes = {};

export default Customers;
